import { render } from "./MfgTzProduceReportDetail.vue?vue&type=template&id=69d12984&scoped=true"
import script from "./MfgTzProduceReportDetail.vue?vue&type=script&lang=js"
export * from "./MfgTzProduceReportDetail.vue?vue&type=script&lang=js"

import "./MfgTzProduceReportDetail.vue?vue&type=style&index=0&id=69d12984&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d12984"]])

export default __exports__